/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

/** React library files */
import React from 'react';

/** Bootstrap */
import { Button, Form } from 'react-bootstrap';

/** React redux */
import store from 'features/store';
import { connect } from 'react-redux';

/** Project library files */
import { getBuyersUrl, getBuyerHeaders } from 'shared/http';
import { invoiceDetail } from 'shared/settings/apiconfig';
import { isAuthorized, logout } from 'shared/settings/auth';
import { PayPalClientId } from 'shared/settings/config';
import Validators from 'shared/validators';

/** Service */
import axios from 'axios';
import authService from 'shared/services/authService';
import { InvoiceService, ItemsService, LocationService } from 'shared/services';

/** Paypal */
import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";

/** Style import */
import './Payment.scss';


/**

@Author Karthik

@param

@return payment html

**/

// const PayPalButton = paypal.Button.driver('react', { React, ReactDOM });

class Payment extends React.Component {
    constructor(props) {
        super(props);
        this.interval = null;
        this.paypalconfig = this.props.location?.state?.payPalConfig;
        this.papaypalstatus = this.props.location?.papaypalstatus;
        this.state = {
            config: this.props.location.state.payPalConfig,
            payPalConfig: {
                script: {
                    "client-id": PayPalClientId,
                    currency: "USD",
                    intent: "capture",
                },
                buttonStyle: {
                    shape: 'pill',
                    color: 'white',
                    layout: 'vertical',
                    label: 'checkout',
                }
            },
            paymentSuccess: false,
            paymentError: false,
            errorMessage: "",
            paymentUpdated: false,
            postData: {},
            paymentStatus: "",
            pageLoading: true,
            noDataFound: false,

            invoiceOrderCreated: false,
            buynowOrderCreated: false,
            inprogress: false,
            orderDetail: {},
            sessionExpire: false,
            warningMessage: false,

            receiptForm: {
                receiptValue: { value: false, error: '', validators: [], valid: true },
                pickupOnly: { value: false, error: '', validators: [], valid: true },
            },
            formValid: false,
            saleitemreceiptmethod: {},
            saleDetail: {},
            isshippable: false
        };
    }

    componentDidMount() {
        /**
         * Checking user is logged in or not. Getting remaining time when user logged in for avoid unauth issues.
         * Show expiry message when refresh token will expiry within 10 min.
         * 
         * Else - Checking user logged in or not. if yes means allow normal process else will show login model.
         */
        // if (isAuthorized() && getRemainingTime() < 10) {
        //     this.setState({
        //         pageLoading: false,
        //         sessionExpire: true
        //     });
        // } else {
        //     if (isAuthorized()) {
        //         this.getRequiredData();
        //     } else {
        //         store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
        //         this.setState({
        //             pageLoading: false
        //         });
        //     }
        // }
        if (isAuthorized()) {
            this.getRequiredData();
            if(this.papaypalstatus){
                this.onApprove();
            }
        } else {
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
            this.setState({
                pageLoading: false
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            if (isAuthorized()) {
                this.setState({
                    sessionExpire: false,
                    pageLoading: true
                }, () => {
                    this.getRequiredData();
                });
            }
        }
    }

    /**
     * Need to get invoice details when come direct link(Invoice link). This method will check path(url) is invoice or not.
     * 
     * If path is invoice means will get invoice details else continue the normal process.
     */
    getRequiredData = () => {
        if (this.props.match.params && this.props.match.params.invoiceId) {
            axios.get(getBuyersUrl(`${invoiceDetail}/${Number(this.props.match.params.invoiceId)}`), getBuyerHeaders())
                .then(response => {
                    let invoiceData = response.data.data[0];
                    let data = JSON.parse(response.data.data[0].details);

                    const locationDetailData = { "sort": [{ "field": "title", "direction": "asc" }] };
                    LocationService.getLocationDetails(data.location, locationDetailData).then(
                        locationResponse => {
                            const locationDetails = locationResponse.data.data;

                            store.dispatch({
                                type: 'PAYPAL_PAYMENT_PAGE',
                                payload: {
                                    amount: parseFloat(invoiceData.pendingamount).toFixed(2),
                                    redirectTo: `/my-account/invoice`,
                                    moreDetails: {
                                        payee: locationDetails[0].paypalemail,
                                        invoicenumber: this.props.match.params.invoiceId,
                                        description: `CTBIDS Invoice Number - ${invoiceData.invoicenumber}, Sale id - ${invoiceData.saleid}`,
                                        reference_id: `CTBIDS Invoice Number - ${invoiceData.invoicenumber}`
                                    }
                                }
                            });
                            // this.setState({
                            //     pageLoading: false,
                            //     noDataFound: false
                            // });
                            this.saleDetailsCheck();
                        }
                    ).catch(error => {
                        this.handleError();
                    });
                }
                ).catch(error => {
                    this.handleError();
                });
        } else {
            // this.handleSuccess();
            this.saleDetailsCheck();
        }
    }

    /**
     * 
     * Getting sale details. Sale details for handle receipt method. if else for handle error.
     * 
     * Getting item or invoice isShippable. Pickup only means checkbox only will show otherwise will show normal receipt method.
     * 
     */
    saleDetailsCheck = () => {

        const item_id = this.props.payPalPage?.moreDetails?.itemId;
        const invoiceNumber = this.props.payPalPage?.moreDetails?.invoicenumber;

        if (item_id) {
            const isshippable = this.props.payPalPage?.moreDetails?.isshippable === 1;
            this.setState({
                isshippable: isshippable,
                receiptForm: {
                    ...this.state.receiptForm,
                    pickupOnly: {
                        ...this.state.receiptForm.pickupOnly,
                        validators: isshippable ? [] : [Validators.required()],
                        valid: isshippable
                    },
                }
            });

            const payload = {
                "field": [
                    'id', 'title', 'saleid', "saletitle", "saleitemreceiptmethod", "itemstatus"
                ]
            };
            ItemsService.getItemDetails(item_id, payload).then(res => {
                const itemDetail = res.data.data[0];
                const saleitemreceiptmethod = JSON.parse(itemDetail.saleitemreceiptmethod);

                if(itemDetail.itemstatus != "Ready") {
                    if (itemDetail.saleid) {
                        this.props.history.push(`/estate-sale/${itemDetail.saleid}`);
                        return;
                    } else {
                        this.props.history.push("/");
                        return;
                    }
                };

                /** Select value when only one available */
                let onlyOneTrue = 0;
                let selectedValue = "";
                Object.keys(saleitemreceiptmethod).forEach(key => {
                    if (saleitemreceiptmethod[key]) {
                        onlyOneTrue = onlyOneTrue + 1;
                        selectedValue = key;
                    }
                });

                /** Checking any one is available. For handling form */
                this.setState({
                    saleDetail: itemDetail,
                    saleitemreceiptmethod,
                    formValid: !(saleitemreceiptmethod.delivery || saleitemreceiptmethod.pickup || saleitemreceiptmethod.shipping)
                }, () => {
                    if (onlyOneTrue === 1) {
                        this.setState({
                            receiptForm: {
                                ...this.state.receiptForm,
                                receiptValue: {
                                    ...this.state.receiptForm.receiptValue,
                                    value: selectedValue,
                                    valid: true,
                                    error: ""
                                }
                            },
                            formValid: !!isshippable
                        });
                    }
                });
                this.alreadyPaidCheck();
            }).catch(error => {
                this.alreadyPaidCheck();
            });
        } else {
            this.props.history.push("/");
            return;
        }

        if (invoiceNumber) {
            InvoiceService.receiptCheck(invoiceNumber).then(res => {
                let temp = res.data.data;
                if (typeof temp === 'object' && temp.data) {
                    temp = temp.data;
                }
                const saleitemreceiptmethod = temp;
                const check = !saleitemreceiptmethod.delivery && !saleitemreceiptmethod.shipping ? !saleitemreceiptmethod.pickup : true;

                /** Select value when only one available */
                let onlyOneTrue = 0;
                let selectedValue = "";
                Object.keys(saleitemreceiptmethod).forEach(key => {
                    if (saleitemreceiptmethod[key]) {
                        onlyOneTrue = onlyOneTrue + 1;
                        selectedValue = key;
                    }
                });

                /** Checking any one is available. For handling form */
                this.setState({
                    saleitemreceiptmethod,
                    formValid: !(saleitemreceiptmethod.delivery || saleitemreceiptmethod.pickup || saleitemreceiptmethod.shipping),
                    isshippable: check,
                    receiptForm: {
                        ...this.state.receiptForm,
                        pickupOnly: {
                            ...this.state.receiptForm.pickupOnly,
                            validators: check ? [] : [Validators.required()],
                            valid: check
                        },
                    }
                }, () => {
                    if (onlyOneTrue === 1) {
                        this.setState({
                            receiptForm: {
                                ...this.state.receiptForm,
                                receiptValue: {
                                    ...this.state.receiptForm.receiptValue,
                                    value: selectedValue,
                                    valid: true,
                                    error: ""
                                }
                            },
                            formValid: !!check
                        });
                    }
                });
                this.alreadyPaidCheck();
            }).catch(error => {
                this.alreadyPaidCheck();
            });
        }
        else{
            this.handleError();
        }
    }

    /** In progress handling */
    alreadyPaidCheck = () => {
        const item_id = this.props.payPalPage?.moreDetails?.itemId;
        const invoiceNumber = this.props.payPalPage?.moreDetails?.invoicenumber;

        if (invoiceNumber) {
            InvoiceService.getInvoiceOrderDetail(invoiceNumber).then(res => {
                const data = res.data.data;
                if (data.length > 0) {
                    if (data[0].paymentstatus === "PENDING") {
                        this.handleSuccess();
                        this.setState({
                            paymentError: true,
                            inprogress: true,
                            errorMessage: "Your Payment is in Progress, please check back again or contact Helpdesk",
                            warningMessage: true
                        });
                    }
                    else {
                        this.handleSuccess();
                    }
                } else {
                    this.handleSuccess();
                }

            }).catch(error => {
                this.handleError();
            });
        }
        if (item_id) {
            InvoiceService.getBuynowDetail(item_id).then(res => {
                const data = res.data.data;
                if (data.length > 0) {
                    if (data[0].paymentstatus === "PENDING") {
                        this.handleSuccess();
                        this.setState({
                            paymentError: true,
                            inprogress: true,
                            errorMessage: "Your Payment is in Progress, please check back again or contact Helpdesk",
                            warningMessage: true
                        });
                    }
                    else {
                        this.handleSuccess();
                    }
                } else {
                    this.handleSuccess();
                }
            }).catch(error => {
                this.handleError();
            });
        }

        if (!item_id && !invoiceNumber) {
            this.handleSuccess();
        }
    }

    /**
     * To show page
     */
    handleSuccess = () => {
        this.setState({
            pageLoading: false,
            noDataFound: false,
            // paymentUpdated: true
        });
    }

    /**
     * To show no-data-found message
     */
    handleError = () => {
        this.setState({ pageLoading: false, noDataFound: true });
    }

    /**
     * To cancel invoice order.
     *  
     * This method will call when page render && when click back after create order.
     * 
     * @returns Promise
     */
    cancelInvoiceOrder = () => {
        const invoiceNumber = this.props.payPalPage.moreDetails.invoicenumber;
        return InvoiceService.cancelInvoiceOrder(invoiceNumber).then(res => res).catch(error => error);
    }

    /**
     * To cancel buynow order.
     *  
     * This method will call when page render && when click back after create order.
     * 
     * @returns Promise
     */
    cancelBuynowOrder = () => {
        const item_id = this.props.payPalPage.moreDetails.itemId;
        return InvoiceService.cancelBuynowOrder(item_id).then(res => res).catch(error => error);
    }

    /**
     * Called When paypal checkout or buynow button click. Based on payment method it will check details.
     * 
     * For items it will check already items is sold or not.
     * 
     * For invoice it will check already invoice paid or not.
     * 
     * @param {*} data 
     * 
     * @param {*} actions 
     * 
     * @returns None
     */
    createOrder(data, actions) {
        const item_id = this.props.payPalPage.moreDetails.itemId;
        const invoicenumber = this.props.payPalPage.moreDetails.invoicenumber;
        if (item_id) {
            return actions.order.create({
                purchase_units: [
                    {
                        description: this.props.payPalPage.moreDetails.description,
                        reference_id: this.props.payPalPage.moreDetails.reference_id,
                        amount: {
                            currency_code: "USD",
                            value: parseFloat(this.props.payPalPage.moreDetails.total_amount),
                            breakdown: {
                                item_total: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.props.payPalPage.moreDetails.total_amount - (this.props.payPalPage.moreDetails.tax_amount + this.props.payPalPage.moreDetails.tax_on_BPAmount + this.props.payPalPage.moreDetails.shipping + this.props.payPalPage.moreDetails.handling)).toFixed(2))
                                },
                                shipping: {
                                    currency_code: "USD",
                                    value: parseFloat(this.props.payPalPage.moreDetails.shipping)
                                },
                                handling: {
                                    currency_code: "USD",
                                    value: parseFloat(this.props.payPalPage.moreDetails.handling)
                                },
                                tax_total: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.props.payPalPage.moreDetails.tax_amount + this.props.payPalPage.moreDetails.tax_on_BPAmount).toFixed(2))
                                }
                            }
                        },
                        payee: {
                            email_address: this.props.payPalPage.moreDetails.payee
                        },
                        // payment_instruction: {
                        //     disbursement_mode: "INSTANT",
                        //     payee_preferred: "IMMEDIATE_PAYMENT_REQUIRED"
                        // },
                        application_context: {
                            user_action: "PAY_NOW",  // Button name, can be PAY_NOW or CONTINUE
                        },
                        items: [
                            {
                                name: this.props.payPalPage.moreDetails.item_name,
                                quantity: 1,
                                sku: this.props.payPalPage.moreDetails.sku,
                                tax: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.props.payPalPage.moreDetails.tax_amount + this.props.payPalPage.moreDetails.tax_on_BPAmount).toFixed(2))
                                },
                                unit_amount: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.props.payPalPage.moreDetails.total_amount - (this.props.payPalPage.moreDetails.tax_amount + this.props.payPalPage.moreDetails.tax_on_BPAmount + this.props.payPalPage.moreDetails.shipping + this.props.payPalPage.moreDetails.handling)).toFixed(2))
                                }
                            }
                        ]
                    },
                ],
            }).then(details => {
                const data = {
                    ordernumber: details,
                    itemid: item_id,
                    gateway: "paypal"
                };
                return InvoiceService.createBuynowOrderDetail({ data }).then(orderDetail => {
                    this.setState({ buynowOrderCreated: true, orderDetail: orderDetail.data.data[0] });
                    return details;
                }).catch(error => {
                    if (error.status === 503) {
                        this.serviceDown();
                    } else {
                        this.setState({
                            paymentError: true,
                            errorMessage: "Oops Something went wrong, please try again or contact CTBids Helpdesk."
                        });
                    }
                    return;
                });
            }).catch(error => {
                if (error.status == 500 || error.name == 'INTERNAL_SERVER_ERROR') {
                    this.setState({
                        paymentError: true,
                        errorMessage: "PayPal Payment Gateway currently unavailable: Your Payment Method could not be stored at this time. Please try again later."
                    });
                }
            });

        } else {
            return actions.order.create({
                purchase_units: [
                    {
                        description: this.props.payPalPage.moreDetails.description,
                        reference_id: this.props.payPalPage.moreDetails.reference_id,
                        amount: {
                            value: this.props.payPalPage.amount,
                        },
                        payee: {
                            email_address: this.props.payPalPage.moreDetails.payee
                        },
                        // payment_instruction: {
                        //     disbursement_mode: "INSTANT",
                        //     payee_preferred: "IMMEDIATE_PAYMENT_REQUIRED"
                        // },
                        application_context: {
                            user_action: "PAY_NOW",  // Button name, can be PAY_NOW or CONTINUE
                        }
                    },
                ],
            }).then(details => {
                const data = {
                    ordernumber: details,
                    invoiceid: invoicenumber,
                    gateway: "paypal"
                };
                return InvoiceService.createInvoiceOrderDetail({ data }).then(orderDetail => {
                    this.setState({ invoiceOrderCreated: true, orderDetail: orderDetail.data.data[0] });
                    return details;
                }).catch(error => {
                    if (error.status === 503) {
                        this.serviceDown();
                    } else {
                        this.setState({
                            paymentError: true,
                            errorMessage: "Oops Something went wrong, please try again or contact CTBids Helpdesk."
                        });
                    }
                    return;
                });
            }).catch(error => {
                this.setState({
                    paymentError: true,
                    errorMessage: "Payment Processing failed. Please try again or contact Seller directly."
                });
                return;
            }).catch(error => {
                if (error.status == 500 || error.name == 'INTERNAL_SERVER_ERROR') {
                    this.setState({
                        paymentError: true,
                        errorMessage: "PayPal Payment Gateway currently unavailable: Your Payment Method could not be stored at this time. Please try again later."
                    });
                }
            });

        }
    }

    /**
     * 
     * After payment happen, this method will call. Method inside will get payment success or failed detail.
     * 
     * Based on some status, payment adding api will call. Otherwise will update api for update transaction details.
     * 
     * 
     * @param {*} data Payment short data
     * 
     * @param {*} actions Action details
     * 
     * @returns None
     */
    onApprove(data, actions) {
        let postData = this.state.config
        this.setState({
            paymentSuccess: true,
            paymentUpdated: false,
            pageLoading: true,
            postData: postData,
            
        });
        authService.paymentSuccess(postData).then(
            response => {
                if (response.status === 202) {
                    const warningMessage = response.data;
                    this.setState({
                        paymentSuccess: true,
                        paymentError: true,
                        inprogress: true,
                        errorMessage: warningMessage.message ? warningMessage.message : response.message ? response.message : null,
                        warningMessage: true,
                        paymentUpdated: true,
                        pageLoading: false,
                    });
                } else {
                    this.setState({
                        paymentSuccess: true,
                        paymentUpdated: true,
                        pageLoading: false,
                    }, () => {
                        // setTimeout(() => {
                        //     this.props.history.push(this.props.payPalPage.redirectTo);
                        // }, 3000);
                    });
                }

            }
        ).catch(error => {
            if (error.status === 503) {
                this.serviceDown();
            } else {
                this.setState({
                    paymentUpdated: true,
                    paymentError: true,
                    errorMessage: error.message ? error.message : "Oops Something went wrong, please try again or contact CTBids Helpdesk.",
                    pageLoading: false,
                });
            }
        });

        // return actions.order.capture().then(details => {
        // //    console.log(JSON.stringify(details), JSON.stringify(data));
        //     const errorData = {
        //         orderid: this.state.orderDetail.id,
        //         orderfailed: {
        //             orderfailedLong: JSON.parse(JSON.stringify(details)),
        //             orderfailedShort: JSON.parse(JSON.stringify(data)),
        //         }
        //     };
        //     if (details.status === "COMPLETED" || details.status === "APPROVED") {
        //         // if (details.purchase_units[0].payments.captures[0].status === "COMPLETED") {
        //         this.setState({
        //             paymentSuccess: true,
        //             paymentStatus: details.status
        //         }, () => {
        //             // if ('payerID' in data && data['payerID']) {
        //             const item_id = this.props.payPalPage.moreDetails.itemId;
        //             const invoicenumber = this.props.payPalPage.moreDetails.invoicenumber;
        //             const postData = {
        //                 "data": {
        //                     "referencenumber": data['orderID'],
        //                     "amount": this.props.payPalPage.amount,
        //                     "credit": 1,
        //                     "paymentmode": "paypal",
        //                     "paymentreference": details?.payer?.email_address ? details?.payer?.email_address : null,
        //                     "status": "completed",
        //                     "partialpayment": 0,
        //                     "buyerid": this.props.user.id
        //                 }
        //             };

        //             if (item_id) {
        //                 postData.data["comments"] = `${item_id}, ${this.props.payPalPage.moreDetails.payee}, ${details.status}`;
        //                 postData.data["itemid"] = item_id;
        //             }

        //             if (invoicenumber) {
        //                 postData.data["comments"] = `${invoicenumber}, ${this.props.payPalPage.moreDetails.payee}, ${details.status}`;
        //                 postData.data["invoiceid"] = invoicenumber;
        //             }
        //             this.setState({
        //                 postData: postData,
        //                 paymentUpdated: true
        //             }, () => {
        //                 authService.paymentSuccess(postData).then(
        //                     response => {
        //                         this.setState({
        //                             paymentUpdated: true
        //                         }, () => {
        //                             // setTimeout(() => {
        //                             //     this.props.history.push(this.props.payPalPage.redirectTo);
        //                             // }, 3000);
        //                         });
        //                     }
        //                 ).catch(error => {
        //                     if (error.status === 503) {
        //                         this.serviceDown();
        //                     } else {
        //                         this.setState({
        //                             paymentError: true,
        //                             errorMessage: "Oops Something went wrong, please try again or contact CTBIDS Helpdesk."
        //                         });
        //                     }
        //                 });
        //             });
        //             // } else {
        //             //     authService.orderUpdate(errorData).then(res => res).catch(error => error);
        //             // }
        //         });
        //         // } else if (details.purchase_units[0].payments.captures[0].status === "PENDING") {
        //         //     this.inProgress();
        //         // } else {
        //         //     this.setState({
        //         //         paymentSuccess: false,
        //         //         paymentStatus: details.status
        //         //     });
        //         // }
        //         // } else if (details.status === "APPROVED") {
        //         //     this.inProgress();
        //     } else {
        //         authService.orderUpdate(errorData).then(res => res).catch(error => error);
        //         this.setState({
        //             paymentSuccess: false,
        //             paymentStatus: details.status
        //         });
        //     }
        // }).catch(error => {
        //     const errorData = {
        //         orderid: this.state.orderDetail.id,
        //         orderfailed: {
        //             orderfailedShort: JSON.parse(JSON.stringify(data)),
        //         }
        //     };
        //     this.onCancel({});
        //     this.setState({
        //         paymentError: true,
        //         errorMessage: "Payment Processing failed. Please try again or contact Seller directly."
        //     });
        //     authService.orderUpdate(errorData).then(res => res).catch(error => error);
        // });
    }

    back = () => {
        if (this.state.paymentError) {
            this.props.history.goBack();
        } else {
            this.props.history.push('/my-account/invoice');
        }
    }

    /**
     * 
     * Need to cancel order in-case they not completed payment.
     * 
     * @param {*} data 
     */
    onCancel = (data) => {
        if (this.state.invoiceOrderCreated) {
            this.cancelInvoiceOrder().then(res => res).catch(error => error);
        }
        if (this.state.buynowOrderCreated) {
            this.cancelBuynowOrder().then(res => res).catch(error => error);
        }
    }

    /**
     * In progress error
     */
    inProgress = () => {
        this.setState({
            paymentError: true,
            inprogress: true,
            errorMessage: "Payment Processing is in progress, Invoice will be updated as Paid when complete."
        });
    }

    /**
     * Service down error
     */
    serviceDown = () => {
        this.setState({
            paymentError: true,
            errorMessage: "We've encountered a problem, please try again or contact CTBids Support via 844-4BID-HELP or <a class='mail-to' href='mailto:ctbidshelp@caringtransitions.com' target='_blank'>ctbidshelp@caringtransitions.com</a>"
        });
    }

    /**
     * using for logout screen without navigating. 
     */
    signoutAndSignin = () => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
        logout(this.props.history, false);
    }

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName = "receiptForm") => {
        let controlError = '';
        let value = null;

        value = event.target.type === 'checkbox' ? event.target.checked ? "true" : null : event.target.value;

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(value);
            if (controlError) break;
        }

        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.type === 'checkbox' && !value ? "false" : value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ formValid: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }
            });
    }

    /**
     * For reuse amount zero condition.
     * 
     * @returns boolean
     */
    amountZeroCondition = () => {
        return !this.state.paymentSuccess && !this.state.paymentError && this.props.payPalPage.amount && parseFloat(this.props.payPalPage.amount) <= 0;
    }

    render() {
        return (
            <div className="payment-page">
                {
                    isAuthorized() ? <div className="back-button">
                        <Button variant="secondary" onClick={this.back}>Go Back</Button>
                    </div> : null
                }
                {
                    isAuthorized() ?
                        <div className="d-flex flex-column align-items-center justify-content-center h-100">
                            {
                                this.state.pageLoading ? <div className="loader">
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                                </div> :
                                    <div className="payment-container d-flex flex-column align-items-center justify-content-center">
                                        {
                                           this.state.errorMessage  ?
                                                <div className="payment-error text-center">
                                                    <i className={`fas ${this.state.warningMessage ? 'fa-exclamation-triangle text-warning' : 'fa-times'} fa-3x`}></i>
                                                    <span className="fa-3x dont-refresh">{this.state.errorMessage ? <span dangerouslySetInnerHTML={{ __html: this.state.errorMessage }}></span> : "Something went wrong please contact Helpdesk"}</span>
                                                </div> :
                                                null
                                        }
                                        {
                                             !this.state.errorMessage  && this.state.postData?.data  && this.state.paymentSuccess &&  this.state.paymentUpdated ?
                                                <div className="payment-success">
                                                    <i className="fas fa-check fa-3x"></i>
                                                    <span className="fa-3x">
                                                        Payment processing Success
                                                    </span>
                                                </div> : null
                                        }
                                        {
                                             !this.state.errorMessage  && this.state.postData?.data  && this.state.paymentSuccess ?
                                                <div>
                                                    <div className="payment-success text-center">
                                                        <h3>Transaction ID: {this.state.postData?.data?.referencenumber}</h3>
                                                    </div>
                                                    <div className="loader d-flex align-items-center justify-content-center text-center">
                                                        <h3>Amount Paid: ${this.state.postData?.data?.amount}</h3>
                                                    </div>
                                                </div> :
                                                null
                                        }
                                        {
                                            this.state.paymentSuccess  ?
                                                <div>
                                                    {
                                                        !this.state.paymentUpdated ?
                                                            <div className="payment-success">
                                                                {/* <i className="fas fa-check fa-3x"></i> */}
                                                                <span className="fa-3x">
                                                                    Payment Processing In Progress. Please wait.
                                                                </span>
                                                            </div> : null
                                                    }
                                                    {
                                                        !this.state.paymentUpdated ?
                                                            <div className="loader d-flex align-items-center justify-content-center">
                                                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                                                            </div> : null
                                                    }
                                                    <div className="text-center h5">
                                                        {this.state.paymentUpdated ? null : "Don't Refresh Screen"}
                                                    </div>
                                                </div> :
                                                null
                                        }
                                        {
                                            !this.state.paymentSuccess && this.state.paymentStatus && this.state.paymentStatus === "COMPLETED" ?
                                                <div className="payment-error">
                                                    <i className="fas fa-times fa-3x"></i>
                                                    <span className="fa-3x dont-refresh">Payment processing failed with PayPal, please try again.</span>
                                                </div> : null
                                        }
                                        {
                                            !this.state.postData?.data ?
                                                <div className="payment-info mb-3">
                                                    {/* <i className="fas fa-info fa-3x"></i> */}
                                                    <span className={`${this.state.noDataFound ? "h3" : "fa-3x"}`}>
                                                        {this.state.noDataFound ? "No Data Found" : "Oops something went wrong please contact CTBids HELPDESK"}
                                                    </span>
                                                </div> :
                                                null
                                        }
                                        {/* {
                                            !this.state.paymentSuccess && this.props.payPalPage.amount ?
                                                <div className="payment-warning">
                                                    <i className="fas fa-exclamation-circle fa-3x"></i>
                                                    <span className="fa-3x dont-refresh">Don't Refresh Screen</span>
                                                </div> :
                                                null
                                        } */}
                                        {
                                            this.state.paymentError ?
                                                <div className="payment-error">
                                                    <div className="text-center h4">
                                                        {
                                                            this.state.inprogress ?
                                                                "" : ""
                                                        }
                                                    </div>
                                                </div> :
                                                null
                                        }

                                        {
                                            this.amountZeroCondition() ?
                                                <div className="payment-info mb-3 text-center">
                                                    {/* <i className="fas fa-info fa-3x"></i> */}
                                                    <span className={`${this.state.noDataFound ? "h3" : "fa-3x"}`}>
                                                        Amount $0.00
                                                    </span>
                                                    <div>
                                                        Amount with $0.00 cannot be processed, Please contact CTBids HELPDESK.
                                                    </div>
                                                </div> :
                                                null
                                        }
                                    </div>
                            }
                        </div> :
                        <div className={`h2 text-center ${this.props.toggleSignInModal?.open ? 'reduce-pad' : ''}`}>
                            Kindly login to make <br></br> payment
                        </div>
                    /*  <div className='show-login d-flex align-items-center justify-content-center h-100'>
                        

                        {
                            this.state.sessionExpire ?
                                <div className={`h2 text-center ${this.props.toggleSignInModal?.open ? 'reduce-pad' : ''}`}>
                                    Your session is about to Expire Please signout and Sign in to process your payment
                                    <div className="pt-12">
                                        <Button variant="secondary" onClick={this.signoutAndSignin}>Sign Out &amp; Sign in</Button>
                                    </div>
                                </div> : <div className={`h2 text-center ${this.props.toggleSignInModal?.open ? 'reduce-pad' : ''}`}>
                                    Kindly login to make <br></br> payment
                                </div>
                        }
                    </div> */
                }
            </div>
        );
    }
}

export default connect(state => state)(Payment);